import React, { forwardRef } from 'react'
import { View } from 'react-native'

import { BaseButton, BaseButtonProps, ButtonType } from '../baseButton/BaseButton'

export type SecondaryTertiaryIconButtonProps = Omit<
  BaseButtonProps,
  'rightIcon' | 'loading' | 'buttonType' | 'text' | 'selected'
>

export const SecondaryTertiaryIconButton = forwardRef<React.ElementRef<typeof View>, SecondaryTertiaryIconButtonProps>(
  (props, ref) => {
    return <BaseButton ref={ref} buttonType={ButtonType.SECONDARY_TERTIARY_ICON} {...props} />
  },
)
